"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (expiredTime) => {
    const currentTime = new Date().getTime() / 1000;
    return currentTime > expiredTime;
};
